import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ISalesFunnelStage } from '@user/store/salesFunnel'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'

type Props = {
  name: string
  label: string
  disabled: boolean
  onChange?: (value: ISalesFunnelStage | null) => void
  density?: DensityType
  salesFunnelStages: ISalesFunnelStage[]
  required?: boolean
}

export function LeadStatusSelect(props: Props) {
  const { name, disabled, salesFunnelStages, onChange, required, ...rest } =
    props

  const statusRequired = required === undefined ? true : required

  const { initialOption, isSubmitting, helperText, showError, ...restUseData } =
    useData({ name, salesFunnelStages, required: statusRequired })

  const { handelChange } = useHandlers({ name })

  return (
    <Box>
      <Select<ISalesFunnelStage>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        error={showError}
        required={statusRequired}
        onChange={(value) => {
          if (onChange) onChange(value)
          handelChange(value)
        }}
        value={initialOption}
        optionMode={'normal'}
        data-test-id="lead-status-select"
        testId="lead-status-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  )
}
